module.exports = __webpack_public_path__ + "static/media/bbq-header.1b78f857.jpg";